export default __webpack_public_path__ + "static/media/skylogo.e36af73a.png";